jQuery(document).ready(function () {
// sorting by player jersey num each div block.
    var gd_container_gk = jQuery(".container-player-profile.gk");
    gd_container_gk.find(".wrapper-player-profile").sort(function(a,b){
      return +a.dataset.playerno - +b.dataset.playerno;
    }).appendTo(gd_container_gk);
    var gd_container_df = jQuery(".container-player-profile.df");
    gd_container_df.find(".wrapper-player-profile").sort(function(a,b){
      return +a.dataset.playerno - +b.dataset.playerno;
    }).appendTo(gd_container_df);
    var gd_container_mf = jQuery(".container-player-profile.mf");
    gd_container_mf.find(".wrapper-player-profile").sort(function(a,b){
      return +a.dataset.playerno - +b.dataset.playerno;
    }).appendTo(gd_container_mf);
    var gd_container_fw = jQuery(".container-player-profile.fw");
    gd_container_fw.find(".wrapper-player-profile").sort(function(a,b){
      return +a.dataset.playerno - +b.dataset.playerno;
    }).appendTo(gd_container_fw);
   
// modal function.
    jQuery(".modal-stats").hide();
    jQuery(document).on("click", ".wrapper-player-profile", function (event) {
      event.preventDefault();
      //jQuery("#modalStats").css("display", "block");
      let person_id = this.id;
      var player_name = jQuery(this).attr("data-name");
      var player_position = jQuery(this).attr("data-position");
      var player_nationality = jQuery(this).attr("data-nationality");
      var player_age = jQuery(this).attr("data-age");
      var player_home_sponsor = jQuery(this).attr("data-home-sponsor");
      var player_home_sponsor_img = jQuery(this).attr("data-home-sponsor-img");
      var player_away_sponsor = jQuery(this).attr("data-away-sponsor");
      var player_away_sponsor_img = jQuery(this).attr("data-away-sponsor-img");
      var player_third_sponsor = jQuery(this).attr("data-third-sponsor");
      var player_third_sponsor_img = jQuery(this).attr("data-third-sponsor-img");
      content="";
      //console.log(person_id);
      jQuery(".modal-stats").show();
      var base_url = "https://api-fai.analyticom.de";
      var teamIdFilter = 10614;
      var teamId = 0; //change depending on ccfc team.
      var api_key = "8f03d750e912f7ff66d3b5eb1ca39f66d762785059470f85723d7513a71ae097106e5b8d3a548b85e60d49ec9fec2471e2086e9cc95f2f22f741f1962d3db004";
      content+="<div class='modal-content'>";
      content+="<span class='close'>&times;</span>";
      content += "<div class='player-detail'>";
      content += "<div class='grp-player-detail'>";
      content+= "<p>Name: <span>"+ player_name +"</span></p>";
      content+= "<p>Nationality: <span>"+ player_nationality +"</span></p>";
      content+= "<p>Age: <span>"+ player_age +"</span></p>";
      content += "</div>";
      /*
      content += "<div class='grp-player-detail sponsor'>";
      if (player_home_sponsor === "" || player_home_sponsor === "undefined") {
        content+= "<p>Home Sponsor: <span>Available to sponsor. Enquire by email.</span></p>";
      }else{
        content+= "<p>Home Sponsor: <span>"+ player_home_sponsor +"</span><img class='sponsor-img' src='"+ player_home_sponsor_img +"' alt='"+ player_home_sponsor +"' loading='lazy'/></p>";
      }
      if (player_away_sponsor === "" || player_away_sponsor === "undefined") {
        content+= "<p>Away Sponsor: <span>Available to sponsor. Enquire by email.</span></p>";
      }else{
        content+= "<p>Away Sponsor: <span>"+ player_away_sponsor +"</span><img class='sponsor-img' src='"+ player_away_sponsor_img +"' alt='"+ player_away_sponsor +"' loading='lazy'/></p>";
      }
      if (player_third_sponsor === "" || player_third_sponsor === "undefined") {
        content+= "<p>Third Sponsor: <span>Available to sponsor. Enquire by email.</span></p>";
      }else{
        content+= "<p>Third Sponsor: <span>"+ player_third_sponsor +"</span><img class='sponsor-img' src='"+ player_third_sponsor_img +"' alt='"+ player_third_sponsor +"' loading='lazy'/></p>";
      }
      content += "</div></div>";
      */
      content += "</div>";
      var api_comp_stat = base_url + "/api/live/player/"+ person_id +"/stats/"+ teamId +"?teamIdFilter="+ teamIdFilter;
//ajax call to get stats data and display it here...
      jQuery.ajax({
        url: api_comp_stat,
        type: "get",
        headers: {"API_KEY": api_key,},
        dataType: "json",
        success: function (res) {
          //console.log(res);
          if (!jQuery.trim(res) || jQuery.trim(res) == null || jQuery.trim(res) == undefined) {
            content += "<div class='empty-val'><p><strong>No stats found.</strong></p></div>";
          }else{
            content += "<div class='grp-tbl'>";
            jQuery.each(res, function (key, value) {
              var matchesPlayed = value?.matchesPlayed;
              var minutesPlayed = value?.minutesPlayed;
              var fullMatchesPlayed = value?.fullMatchesPlayed;
              var goals = value?.goals;
              var assists = value?.assists;
              var yellowCards = value?.yellowCards;
              var redCards = value?.redCards;
              var comp_name = value?.competition.name;
              var comp_parentname = value?.competition.parentName;
              var comp_id = value?.competition.id;
              //console.log(value?.competition.name);
              if(comp_name != '22/23 SSE Airtricity League First Division' || comp_id === '180529'){
                if(player_position === "GK"){
                  if(comp_id != '1929205'){
                    content += "<div id='id"+ comp_id +"' class='tbl-stat'><div class='tbl-header'><h4>"+comp_name+"</h4></div>";
                  }else{
                    content += "<div id='id"+ comp_id +"' class='tbl-stat'><div class='tbl-header'><h4>"+comp_parentname+"</h4></div>";
                  }
                  content += "<table><thead><tr>";
                  content += "<th>APPS</th>";
                  content += "<th>MINS</th><th>PLAYED</th>";
                  content += "<th>ASSISTS</th><th>YELLOWS</th><th>REDS</th>";
                  content += "</tr></thead><tbody><tr>";
                  if (!jQuery.trim(matchesPlayed) || jQuery.trim(matchesPlayed) == null || jQuery.trim(matchesPlayed) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ matchesPlayed +"</td>";}
                  if (!jQuery.trim(minutesPlayed) || jQuery.trim(minutesPlayed) == null || jQuery.trim(minutesPlayed) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ minutesPlayed +"</td>";}
                  if (!jQuery.trim(fullMatchesPlayed) || jQuery.trim(fullMatchesPlayed) == null || jQuery.trim(fullMatchesPlayed) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ fullMatchesPlayed +"</td>";}
                  if (!jQuery.trim(assists) || jQuery.trim(assists) == null || jQuery.trim(assists) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ assists +"</td>";}
                  if (!jQuery.trim(yellowCards) || jQuery.trim(yellowCards) == null || jQuery.trim(yellowCards) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ yellowCards +"</td>";}
                  if (!jQuery.trim(redCards) || jQuery.trim(redCards) == null || jQuery.trim(redCards) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ redCards +"</td>";}
                  content += "</tr></tbody></table></div>";
                }else{
                  if(comp_id != '1929205'){
                    content += "<div id='id"+ comp_id +"' class='tbl-stat'><div class='tbl-header'><h4>"+comp_name+"</h4></div>";
                  }else{
                    content += "<div id='id"+ comp_id +"' class='tbl-stat'><div class='tbl-header'><h4>"+comp_parentname+"</h4></div>";
                  }             
                  content += "<table><thead><tr>";
                  content += "<th>APPS</th>";
                  content += "<th>MINS</th><th>PLAYED</th>";
                  content += "<th>GOALS</th><th>ASSISTS</th><th>YELLOWS</th><th>REDS</th>";
                  content += "</tr></thead><tbody><tr>";
                  if (!jQuery.trim(matchesPlayed) || jQuery.trim(matchesPlayed) == null || jQuery.trim(matchesPlayed) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ matchesPlayed +"</td>";}
                  if (!jQuery.trim(minutesPlayed) || jQuery.trim(minutesPlayed) == null || jQuery.trim(minutesPlayed) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ minutesPlayed +"</td>";}
                  if (!jQuery.trim(fullMatchesPlayed) || jQuery.trim(fullMatchesPlayed) == null || jQuery.trim(fullMatchesPlayed) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ fullMatchesPlayed +"</td>";}
                  if (!jQuery.trim(goals) || jQuery.trim(goals) == null || jQuery.trim(goals) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ goals +"</td>";}
                  if (!jQuery.trim(assists) || jQuery.trim(assists) == null || jQuery.trim(assists) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ assists +"</td>";}
                  if (!jQuery.trim(yellowCards) || jQuery.trim(yellowCards) == null || jQuery.trim(yellowCards) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ yellowCards +"</td>";}
                  if (!jQuery.trim(redCards) || jQuery.trim(redCards) == null || jQuery.trim(redCards) == undefined) {
                    content += "<td>-</td>";
                  }else{content += "<td>"+ redCards +"</td>";}
                  content += "</tr></tbody></table></div>";
                }
              }
            });
            content += "</div>";
          }
          content+="</div>";
          jQuery('.modal-stats').html(content);
        },
        error: function (errorThrown) {
          //console.log(errorThrown);
          content += "<div class='empty-val'><p><strong>No stats found.</strong></p></div>";
          jQuery('.modal-stats').html(content);
        },
      });
      jQuery('.modal-stats').html(content);
    });
    jQuery(document).on("click", ".close", function (event) {jQuery("#modalStats").css("display", "none");});
    /*
    jQuery(document).on("click", function(e){
      if(!((jQuery(e.target).closest("#modalStats").length > 0 ) || (jQuery(e.target).closest("#modalStats").length > 0))){
        jQuery("#modalStats").css("display", "none");
      }
    });
    */
});